import ChannelChat from 'app/shared-components/chat/ChannelChat';
import ChatEntry from 'app/shared-components/chat/ChatEntry';
import { Box } from '@mui/material';
import { useSelector, useDispatch} from 'react-redux';
import { useEffect } from 'react';
import { selectPostById, fetchPost } from 'app/store/postSlice';
import { selectChannel } from 'app/store/channelsSlice';

function CommentPanel({ postId, isNotes, isView, initialMessage, commentChannelId, hidePost, textOnly, loadPost } ) {
  const dispatch= useDispatch();
  const post= useSelector(selectPostById(postId));
  const channelId = post ? post.channelId : null;
  const channel = useSelector(selectChannel(channelId));
  const useChannelId= post ? post.commentChannelId : commentChannelId;

    console.log("Inside CommentPanel");
    console.log(postId);
    console.log(useChannelId);
  
  useEffect(() => {
  	if (loadPost && postId && !post)
     dispatch(fetchPost(postId));
  }, [postId, loadPost])
  
  if (!useChannelId) return null;
  
  return (
	
	  <Box className="w-full h-full" 
	     sx={{
          display: 'flex',
          alignItems: 'flex-start',
          flexDirection: 'column',
         }}
      >
      
      {!hidePost && post &&
	    <Box sx={{ flexGrow: 0 }} className='w-full pl-10 pt-10'>
			  <ChatEntry 
			        key={post.id} 
	            postId={post.id} 
	            rootChannelId={channel.rootId}  
	            permissions={channel.callerPermissions} 
	            firstOfGroup={true}
	            lastOfGroup={false}
	            lastOfChannel={false}
	            disableComments={true}
	         />
	    </Box>
	    }
	    <Box sx={{ flexGrow: 1, minHeight: 0 }} className={'w-full'} >            
		   <ChannelChat channelId={useChannelId} parentPostId={postId} disableComments={true} 
		                initialMessage={initialMessage} isNotes={isNotes} isView={isView} textOnly={textOnly} />
		  </Box>
    </Box>
  );
}

export default CommentPanel;
